import { Theme } from "@mui/material/styles/createThemeNoVars";
import { createContext, Dispatch, SetStateAction } from "react";

export type ImagePath = string;

export interface BidThemeContextType {
  pwaName: string;
  setPwaName: Dispatch<SetStateAction<string>>;
  theme: Theme;
  setTheme: Dispatch<SetStateAction<Theme>>;
  logo: ImagePath;
  setLogo: Dispatch<SetStateAction<ImagePath>>;
  favicon: ImagePath;
  setFavicon: Dispatch<SetStateAction<ImagePath>>;
}

export default createContext<BidThemeContextType>({
  pwaName: "Tá Quitado",
  setPwaName: ((_newPwaName: string) => {}) as Dispatch<SetStateAction<string>>,
  theme: {} as Theme,
  setTheme: ((_newTheme: Theme) => {}) as Dispatch<SetStateAction<Theme>>,
  logo: "",
  setLogo: ((_newLogo: ImagePath) => {}) as Dispatch<SetStateAction<ImagePath>>,
  favicon: "",
  setFavicon: ((_newFavicon: ImagePath) => {}) as Dispatch<SetStateAction<ImagePath>>,
});
